import { NavLink } from 'react-router-dom'
import { NAV_ITEMS, type NavItem } from './navigation'

// The bar keeps its four slots; Sales Team is reached from Quick Actions there.
const item = (to: string) => NAV_ITEMS.find((entry) => entry.to === to) as NavItem
import { QuickActionMenu } from './QuickActionMenu'

function MobileNavLink({ item }: { item: (typeof NAV_ITEMS)[number] }) {
  const { label, to, icon: Icon } = item

  return (
    <NavLink
      aria-label={label}
      className={({ isActive }) =>
        `mobile-nav-link${isActive ? ' is-active' : ''}`
      }
      to={to}
    >
      <span className="mobile-nav-icon">
        <Icon
          aria-hidden="true"
          size={21}
          strokeWidth={1.8}
        />
      </span>

      <span className="mobile-nav-label">
        {label}
      </span>
    </NavLink>
  )
}

export function MobileNav({
  onAddNewProspect,
  onAddSalesperson,
  onSetReminder,
  onReviewMissingInformation,
  onOpenScript,
}: {
  onAddNewProspect: (trigger: HTMLButtonElement) => void
  onAddSalesperson?: (trigger: HTMLButtonElement) => void
  onSetReminder: (trigger: HTMLButtonElement) => void
  onReviewMissingInformation: (trigger: HTMLButtonElement) => void
  onOpenScript?: (trigger: HTMLButtonElement) => void
}) {
  return (
    <nav className="mobile-nav" aria-label="Primary navigation">
      <MobileNavLink item={item('/dashboard')} />
      <MobileNavLink item={item('/leads')} />
      <QuickActionMenu onAddNewProspect={onAddNewProspect} onAddSalesperson={onAddSalesperson} onSetReminder={onSetReminder} onReviewMissingInformation={onReviewMissingInformation} onOpenScript={onOpenScript} variant="mobile" />
      <MobileNavLink item={item('/analytics')} />
      <MobileNavLink item={item('/profile')} />
    </nav>
  )
}

